/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { AiOutlineMenu } from 'react-icons/ai';
import { ExitToApp } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useStateContext } from '../contexts/ContextProvider';
import SimpliSafe from '../data/SimpliSafe.png';
import avatar_1 from '../data/avatar_1.png';

const NavButton = ({ customFunc, icon, color }) => (
  <button
    type="button"
    onClick={() => customFunc()}
    style={{ color }}
    className="text-xl rounded-full p-2 hover:bg-gray-100 transition"
  >
    {icon}
  </button>
);

const Navbar = () => {
  const { currentColor, activeMenu, setActiveMenu, setScreenSize, screenSize } = useStateContext();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  // Resize logic
  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setActiveMenu(screenSize > 900);
  }, [screenSize]);

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to logout!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem('loginID');
        navigate('/');
      }
    });
  };

  const loginUser = JSON.parse(localStorage.getItem('loginID'));
  const handleActiveMenu = () => {
    setActiveMenu(!activeMenu);
  };

  return (
    <header className="w-full h-14 flex items-center justify-between px-4 shadow-sm" style={{ background: 'linear-gradient(to right, #060047 , #00FFFF  )', borderRadius: '10px', margin: '-10px 0 0 0 ' }}>
      {/* Left: Menu + Logo */}
      <button
        onClick={handleActiveMenu}
        id="naviagebtn"
        style={{ display: 'none' }}
      >
        Navigate Button
      </button>
      <div className="flex items-center gap-3">
        <NavButton
          customFunc={() => setActiveMenu(!activeMenu)}
          color={currentColor}
          icon={<AiOutlineMenu />}
        />
        <img
          src={SimpliSafe}
          alt="logo"
          className="h-12 object-contain"
        />
      </div>

      {/* Right: User info */}
      {loginUser && (
        <div
          className="flex items-center gap-2 cursor-pointer p-1 rounded-lg bg-white hover:bg-gray-100 relative"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <img
            className="rounded-full w-8 h-8"
            src={avatar_1}
            alt="user-profile"
          />
          <span className="font-medium text-gray-800 flex items-center">
            {loginUser.UserName}
            {isDropdownOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </span>
          {/* Dropdown */}
          {isDropdownOpen && (
            <div className="absolute right-0 top-full mt-2 bg-white shadow-md rounded-lg z-50">
              <ul className="list-none">
                <li
                  className="py-2 px-4 flex items-center cursor-pointer hover:bg-gray-50"
                  onClick={handleLogout}
                >
                  <ExitToApp sx={{ fontSize: 24, color: 'red' }} />
                  <Typography variant="body1" color="red" sx={{ ml: 1 }}>
                    Logout
                  </Typography>
                </li>
              </ul>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default Navbar;
